import fetch from "isomorphic-fetch";
import { useHistory } from "react-router-dom";
import { API } from "../config";
import { getCookie, userSessionExpired } from "./auth";
const Role = () => {
  const history = useHistory();
  const addProduct = (product) => {
    return fetch(`${API}/purchase-products`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${getCookie("token")}`,
      },
      body: JSON.stringify(product),
    })
      .then((response) => {
        userSessionExpired(response, history);
        return response.json();
      })
      .catch((err) => err);
  };
  const addProductFromFile = (product, purchaseOrderId) => {
    return fetch(`${API}/purchase-products/from-file/${purchaseOrderId}`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${getCookie("token")}`,
      },
      body: JSON.stringify(product),
    })
      .then((response) => {
        userSessionExpired(response, history);
        return response.json();
      })
      .catch((err) => err);
  };
  const updateProduct = (role, Id) => {
    return fetch(`${API}/purchase-products/${Id}`, {
      method: "PATCH",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${getCookie("token")}`,
      },
      body: JSON.stringify(role),
    })
      .then((response) => {
        userSessionExpired(response, history);
        return response.json();
      })
      .catch((err) => err);
  };

  const updateContainer = (data, Id) => {
    return fetch(`${API}/purchase-products/container/${Id}`, {
      method: "PATCH",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${getCookie("token")}`,
      },
      body: JSON.stringify(data),
    })
      .then((response) => {
        userSessionExpired(response, history);
        return response.json();
      })
      .catch((err) => err);
  };
  const updatePurchaseList = (role, Id) => {
    return fetch(`${API}/purchase-products/list/${Id}`, {
      method: "PATCH",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${getCookie("token")}`,
      },
      body: JSON.stringify(role),
    })
      .then((response) => {
        userSessionExpired(response, history);
        return response.json();
      })
      .catch((err) => err);
  };
  const deleteProduct = (Id) => {
    return fetch(`${API}/purchase-products/${Id}`, {
      method: "DELETE",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${getCookie("token")}`,
      },
    })
      .then((response) => {
        userSessionExpired(response, history);
        return response.json();
      })
      .catch((err) => err);
  };
  const deleteProductList = (Id) => {
    return fetch(`${API}/purchase-products/list/${Id}`, {
      method: "DELETE",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${getCookie("token")}`,
      },
    })
      .then((response) => {
        userSessionExpired(response, history);
        return response.json();
      })
      .catch((err) => err);
  };
  const getProduct = (Id) => {
    return fetch(`${API}/purchase-products/${Id}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${getCookie("token")}`,
      },
    })
      .then((response) => {
        userSessionExpired(response, history);
        return response.json();
      })
      .catch((err) => err);
  };

  const viewAllProducts = (purchaseOrderId) => {
    return fetch(
      `${API}/purchase-products/?purchaseOrderId=${purchaseOrderId}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${getCookie("token")}`,
        },
      }
    )
      .then((response) => {
        userSessionExpired(response, history);
        return response.json();
      })
      .catch((err) => err);
  };
  const viewAllProductsWithPages = (
    page,
    limit,
    searchQuery,
    purchaseOrderId
  ) => {
    return fetch(
      `${API}/purchase-products/pages/?page=${page}&limit=${limit}&search=${searchQuery}&purchaseOrderId=${purchaseOrderId}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${getCookie("token")}`,
        },
      }
    )
      .then((response) => {
        userSessionExpired(response, history);
        return response.json();
      })
      .catch((err) => err);
  };
  const viewAllProductsLists = () => {
    return fetch(`${API}/purchase-products/list`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${getCookie("token")}`,
      },
    })
      .then((response) => {
        userSessionExpired(response, history);
        return response.json();
      })
      .catch((err) => err);
  };
  const viewAllPurchasesByContainer = () => {
    return fetch(`${API}/purchase-products/by-container`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${getCookie("token")}`,
      },
    })
      .then((response) => {
        userSessionExpired(response, history);
        return response.json();
      })
      .catch((err) => err);
  };
  const viewAllPurchasesByContainerWithPages = (
    page,
    limit,
    searchQuery,
    containerName,
    orderId
  ) => {
    return fetch(
      `${API}/purchase-products/by-container/pages/?page=${page}&limit=${limit}&search=${searchQuery}&containerName=${containerName}&orderId=${orderId}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${getCookie("token")}`,
        },
      }
    )
      .then((response) => {
        userSessionExpired(response, history);
        return response.json();
      })
      .catch((err) => err);
  };
  const viewTotalPriceByContainer = (
    containerName,
    orderId
  ) => {
    return fetch(
      `${API}/purchase-products/by-container/price?containerName=${containerName}&orderId=${orderId}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${getCookie("token")}`,
        },
      }
    )
      .then((response) => {
        userSessionExpired(response, history);
        return response.json();
      })
      .catch((err) => err);
  };
  const viewTotalProducts = () => {
    return fetch(`${API}/products/total`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${getCookie("token")}`,
      },
    })
      .then((response) => {
        userSessionExpired(response, history);
        return response.json();
      })
      .catch((err) => err);
  };
  const publishPurchaseProduct = (product) => {
    return fetch(`${API}/products/publish`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${getCookie("token")}`,
      },
      body: JSON.stringify(product),
    })
      .then((response) => {
        userSessionExpired(response, history);
        return response.json();
      })
      .catch((err) => err);
  };
  const publishPurchaseProducts = (product) => {
    return fetch(`${API}/products/publish-product`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${getCookie("token")}`,
      },
      body: JSON.stringify(product),
    })
      .then((response) => {
        userSessionExpired(response, history);
        return response.json();
      })
      .catch((err) => err);
  };
  return {
    addProduct,
    viewTotalProducts,
    deleteProduct,
    updateProduct,
    viewAllProducts,
    getProduct,
    addProductFromFile,
    updatePurchaseList,
    deleteProductList,
    viewAllProductsLists,
    viewAllPurchasesByContainer,
    updateContainer,
    publishPurchaseProduct,
    publishPurchaseProducts,
    viewAllProductsWithPages,
    viewAllPurchasesByContainerWithPages,
    viewTotalPriceByContainer
  };
};

export default Role;
